























































import { Partner } from '@/modules/kartoteka/partner';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import ZakazkaSelect from '@/modules/servis/zakazka/components/Select.vue';
import { listFactory } from '@/main/pages';

import { getColumnsRowMapObject, Row, intToRgb } from '@/main/utils/table';

import InfoSideBar from '#components/dms/InfoSideBar/InfoSideBar.vue';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

// Do not replace with Zakazka - it would create a circular reference.

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		ZakazkaSelect,
		InfoSideBar,
	},
	data() {
		return {
			showInfoSideBar: false,
			followUpDataMessage: this.LocalizeChyboveHlasky('LEADFOLLOWUP'),
			Notification: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
			timeout: null as any | null,
			DefaultWarehouseId: null as any | 0,
		};
	},
	computed: {
		mutationsMappers() {
			return {
				nr: `${this.storeUri}/${listMutations.OZAKAZKA_LIST_NR_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${listMutations.OZAKAZKA_LIST_ZAKAZNIK_SELECT_MAPPER}`,
				vstupPrac: `${this.storeUri}/${listMutations.OZAKAZKA_LIST_VSTUP_PRAC_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		tableCellStyle({ row }:{ row: Row, column: any }) {
			const data = getColumnsRowMapObject(this.table.columns, row.cells);
			if (data.IS_CUSTOMER_FIRST_VISIT && this.dmsSys.CustomerFirstPrp) {
				return { background: intToRgb(row.cells[this.cellNames.FIRST_VISIT_COLOR_CODE]) };
			}
			return null;
		},
	},

});
